import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { fetchEventPromptsList } from 'gqlQueries/promoRecommendation';

const errorMessage: string = 'Something went wrong!';

function useFetchGetPromptsPreviousList(slice = 0) {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>([]);

    //To fetch dim
    const [fetchPromptPreviousList, { data: promptData, loading: promptLoading, error: promptError }] = useLazyQuery(
        fetchEventPromptsList,
        {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        },
    );

    useEffect(() => {
        setLoading(promptLoading);
    }, [promptLoading]);

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            let list = payload.getEventPromptsList.map((offerList: any) => {
                return {
                    ...offerList,
                    value: offerList.eventName.slice(slice),
                    label: offerList.eventName.replace(/_/g, ' '),
                };
            });
            setData(() => list);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchPromptPreviousList: (variables: any) => {
            fetchPromptPreviousList(variables);
        },
    };
}

export default useFetchGetPromptsPreviousList;
